import React, {useEffect, useMemo} from "react";
import {Button, Col, Row} from "antd";
import BookCover from "@components/book-cover";
import {useGetCollectionIssuesQuery} from "@mwServices/User";
import {getMyCollectionUrlWithIssueId} from "@lib/Routes";


const HomePageMyComics = ({windowDimensions, showDesktopView, onLoad}) => {

    const issueQuery = useGetCollectionIssuesQuery({filters: { showVariants: true, sort: 2, groupByIssue: true }, page: 1, perPage: 8 });
    const issues = useMemo(() => {
        if (issueQuery.data && issueQuery.data.issues) {
            let numComics = 8;
            if(windowDimensions.under(1201)) numComics = 7;
            if(windowDimensions.under(1001)) numComics = 6;
            if(windowDimensions.under(901)) numComics = 5;
            if(windowDimensions.under(800)) numComics = 6;
            if(windowDimensions.under(651)) numComics = 5;
            if(windowDimensions.under(551)) numComics = 4;
            if(windowDimensions.under(500)) numComics = 3;
            if(windowDimensions.under(430)) numComics = 2;

            return issueQuery.data.issues.slice(0, numComics);
        } else {
            return [];
        }
    }, [issueQuery, windowDimensions]);

    useEffect(() => {
        if(issueQuery.data) onLoad();
    }, [issueQuery]);

    const showNoIssues = useMemo(() => {
        return issueQuery.data && issueQuery.data.issues && issueQuery.data.issues.length === 0;
    }, [issueQuery]);

    return (
        <Row className="my-comics">
            <Col span={showDesktopView ? 8 : 12}>
                <div className="my-comics-info">
                    <span className="my-comics-title">My Trending Comics</span><br/>
                    <Button className="my-comics-button" href="/my-collection">{showNoIssues ? 'Add Comics' : 'Go To Collection'}</Button>
                </div>
            </Col>
            <Col span={showDesktopView ? 16 : 12}>
                <div className="flex-row my-comics-row">
                {issues && issues.map((issue,i) => (
                    <div key={i} style={{position: 'relative'}}>
                        <a href={getMyCollectionUrlWithIssueId(issue.id)}>
                            <BookCover issue={issue} preview={false} size={'small'} />
                        </a>
                    </div>
                    ))}
                    {showNoIssues && (
                        <div className="no-comics">
                            You Have 0 Comics In Your Collection.<br/>
                            <a href="/my-collection">Add Comics</a>
                        </div>
                    )}
                </div>
            </Col>
        </Row>
);
};

export default HomePageMyComics;